module.exports = __webpack_public_path__ + "static/img/Element.17f80c85.png";